// Machinery catalogue — White Bull Global
// 6 machines based on Samarika Pharma Solutions quotations (Sept 2025)

import rapidMixerGranulatorImg from "../assets/machinery/rapid-mixer-granulator.jpg";
import fluidBedDryerImg from "../assets/machinery/fluid-bed-dryer.jpg";
import massMixerImg from "../assets/machinery/mass-mixer.jpg";
import capsuleFillingMachineImg from "../assets/machinery/capsule-filling-machine.jpg";
import tabletPressImg from "../assets/machinery/tablet-press.jpg";
import octagonalBlenderImg from "../assets/machinery/octagonal-blender.jpg";

export const MACHINERY = [
  {
    slug: "rapid-mixer-granulator",
    name: "Rapid Mixer Granulator",
    category: "Granulation",
    icon: "Layers",
    short:
      "High-speed mixer granulator for efficient blending and consistent granule formation across nutraceutical and pharmaceutical formulations. SS 316 contact parts, cGMP compliant.",
    image: rapidMixerGranulatorImg,
    details: null,
  },
  {
    slug: "fluid-bed-dryer",
    name: "Fluid Bed Dryer",
    category: "Drying",
    icon: "Wind",
    short:
      "Batch fluid bed dryer for fast, uniform drying of granules — suitable for heat-sensitive and standard products. Automatic temperature controls, washable FDA-approved filter media.",
    image: fluidBedDryerImg,
    details: null,
  },
  {
    slug: "mass-mixer",
    name: "Mass Mixer",
    category: "Blending",
    icon: "Layers",
    short:
      "Paddle-type U-trough mass mixer for homogeneous blending of thick, heavy powder materials. PTFE gland mechanism prevents contamination and leakage. cGMP compliant.",
    image: massMixerImg,
    details: null,
  },
  {
    slug: "capsule-filling-machine",
    name: "Automatic Capsule Filling Machine",
    category: "Capsule Line",
    icon: "Pill",
    short:
      "Automatic capsule filling machine with vacuum cap-body separation and precision dosator slug system. Handles powders, granules and pellets with high fill-weight accuracy.",
    image: capsuleFillingMachineImg,
    details: null,
  },
  {
    slug: "tablet-press",
    name: "Rotary Tablet Press",
    category: "Tablet Line",
    icon: "Tablets",
    short:
      "20-station D-tooling rotary tablet press for compressed tablet production. Suitable for a range of tablet sizes and formats, with controlled compression pressure.",
    image: tabletPressImg,
    details: null,
  },
  {
    slug: "octagonal-blender",
    name: "Octagonal Blender",
    category: "Blending",
    icon: "Box",
    short:
      "Octagonal blender for gentle, uniform mixing and lubrication of dry granules and powders. GMP-compliant design with baffles for fast, efficient blending and easy discharge.",
    image: octagonalBlenderImg,
    details: null,
  },
];

export const MACHINERY_NOTE =
  "Detailed specifications and machine photographs will be published here. For current line specifics, contact our team or request a quote.";
